import { getThumbBySize } from '../../../../../../util/photo';
import { HIERARCHY_ITEM_TYPE } from '../../../../../../constants/albums';
import { IMAGE_SIZE_CODE } from '../../../../../../constants/image-size-codes';
import { CONTRIBUTOR_UPLOAD_ACCESS } from '../../../../../../constants/contributors';

export const getGalleriesFromHierarchyItems = hierarchyItems => {
  const { ALBUM, ALBUM_FOLDER } = HIERARCHY_ITEM_TYPE;

  return hierarchyItems
    .filter(entity => [ALBUM_FOLDER, ALBUM].includes(entity.item_type))
    .map(originalEntity => {
      const {
        id,
        album,
        albums,
        album_folder: albumFolder,
        item_type: entityType,
      } = originalEntity;
      const entity = album || albumFolder;

      const coverPhotoRecord =
        entityType === ALBUM_FOLDER
          ? originalEntity.album_folder.cover_photos?.records?.[0] ?? undefined
          : originalEntity.album?.cover_photo ?? undefined;
      const coverPhotoUrl = coverPhotoRecord
        ? getThumbBySize(
            coverPhotoRecord.thumbnail_urls,
            IMAGE_SIZE_CODE.LARGE2X,
          ).url
        : undefined;

      return {
        id,
        album,
        album_folder: albumFolder,
        childAlbumCount: entityType === ALBUM_FOLDER ? albums.total : undefined,
        coverPhotoUrl,
        name: entity.name,
        type: entityType,
        start_date: entity.start_date,
        end_date: entity.end_date,
        hasUploadPermissions:
          !!entity.auto_contributor_settings?.upload_access &&
          entity.auto_contributor_settings?.upload_access !==
            CONTRIBUTOR_UPLOAD_ACCESS.NONE,
      };
    });
};
